import React from 'react'
import { useTranslation } from 'react-i18next'

import Card from 'components/Shared/Card'
import NoDataComp from 'components/Shared/NoData'
import ClusterMap from 'components/Reporting/Overview/GraphicalDetails/ContributionsLocation/ClusterMap'
import CardSkeleton from 'components/Shared/SkeletonStack/Card/CardSkeleton'
import {
  contributorsData as contributorsDataType,
  ContributionsLocation as ContributionsLocationType,
} from 'types/ContributionsLocation'
import { isFrenchLocale } from 'lib/utility/LocaleHelper'
import { useAppSelector } from 'redux/Hook'

type ContributionsLocationCardProps = {
  isLoading: boolean
  contributionsLocationData: ContributionsLocationType
}

const ContributionsLocation = ({
  contributionsLocationData,
  isLoading,
}: ContributionsLocationCardProps) => {
  const { t } = useTranslation()
  const {
    stakeholderDashboardDetails: { accessToken = '' },
  }: any = useAppSelector((state) => state)

  const buildSkeleton = (
    <CardSkeleton
      showHeaderSkeleton={false}
      sectionCount={1}
      height={'31.5rem'}
    />
  )

  const checkIfDataExists = () => contributionsLocationData?.data?.length > 0

  const getDataComp = () => {
    const data: contributorsDataType = contributionsLocationData?.data?.[0]

    return (
      <ClusterMap
        height="31.5rem"
        contributionsLocationData={{
          bounds: data?.bounds,
          maps: data?.maps,
        }}
        language={isFrenchLocale() ? 'french' : 'english'}
      />
    )

    return <NoDataComp noDataImageClass="contributors-location-empty-state" />
  }

  const contributedLocationsContent = () => {
    return isLoading ? buildSkeleton : getDataComp()
  }

  return (
    <Card
      topContentSpacing="none"
      cardSizeClass="contributors-location"
      info={contributionsLocationData?.info}
      showMoreAction={checkIfDataExists() && !accessToken}
      content={contributedLocationsContent()}
      header={t('reporting.overview.contributionsLocation')}
    />
  )
}

export default ContributionsLocation
